import { Field, Form, Formik } from "formik";
import { useState } from "react";
import { FiArrowLeft, FiArrowRight, FiEye, FiEyeOff } from "react-icons/fi";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import * as Yup from "yup";
import AuthLink from "./AuthLink";

const passwordSchema = Yup.object({ password: Yup.string().required("Enter your Akello password.") });

const SocialPasswordConfirmation = ({ email, busy, error, inputRef, onSubmit, onBack }) => {
	const [showPassword, setShowPassword] = useState(false);
	return (
		<Formik initialValues={{ password: "" }} validationSchema={passwordSchema} onSubmit={onSubmit}>
			{({ isSubmitting }) => {
				const submitting = busy || isSubmitting;
				return (
					<Form className="social-connect__form">
						<div className="social-connect__field-label">
							<label htmlFor="social-connect-password">Akello password</label>
							<AuthLink
								mode="password-reset"
								resetEmail={email?.includes("@") ? email : undefined}
								className="social-connect__forgot"
								tabIndex={submitting ? -1 : 0}
								aria-disabled={submitting || undefined}
								onClick={(event) => { if (submitting) event.preventDefault(); }}
							>
								Forgot password?
							</AuthLink>
						</div>
						<Field name="password">
							{({ field, meta }) => (
								<>
									<div className="social-connect__password">
										<input
											{...field}
											ref={inputRef}
											id="social-connect-password"
											type={showPassword ? "text" : "password"}
											autoComplete="current-password"
											placeholder="Enter your Akello password"
											disabled={submitting}
											aria-invalid={Boolean(meta.touched && meta.error)}
											aria-describedby={meta.touched && meta.error ? "social-connect-password-error" : undefined}
										/>
										<button type="button" disabled={submitting} aria-label={showPassword ? "Hide password" : "Show password"} aria-pressed={showPassword} onClick={() => setShowPassword(!showPassword)}>
											{showPassword ? <FiEyeOff aria-hidden="true" /> : <FiEye aria-hidden="true" />}
										</button>
									</div>
									{meta.touched && meta.error ? <p id="social-connect-password-error" role="alert" className="social-connect__error">{meta.error}</p> : null}
								</>
							)}
						</Field>
						{error ? <p role="alert" className="social-connect__error">{error}</p> : null}
						<button type="submit" disabled={submitting || !email} className="social-connect__button social-connect__button--primary">
							<span>{submitting ? "Connecting your account…" : "Connect and continue"}</span>
							{submitting ? <AiOutlineLoading3Quarters className="animate-spin" aria-hidden="true" /> : <FiArrowRight aria-hidden="true" />}
						</button>
						<button type="button" disabled={submitting} onClick={onBack} className="social-connect__back"><FiArrowLeft aria-hidden="true" /> Back to account options</button>
					</Form>
				);
			}}
		</Formik>
	);
};

export default SocialPasswordConfirmation;
